import React, { useEffect, useState } from "react";
import folder from "../../../assets/svg/folder.svg";
import { useNavigate } from "react-router";
import document from "../../../assets/svg/documentActive.svg";
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import arrowright from "../../../assets/svg/arrow-right.svg";
import arrowleft from "../../../assets/svg/arrow-left.svg";
import Pagination from "react-js-pagination";
import { ToastContainer, toast } from "react-toastify";
import LeftArrowIcon from "../../../assets/svg/LeftArrow.svg";
import RightArrowIcon from "../../../assets/svg/RightArrow.svg";
import { POST_CATEGORIES } from "../../../helpers/endpointService";
import axios from "axios";
import { setCategoryData } from "../../../redux/action/Action";
import { PulseLoader } from "react-spinners";
import { logoutFunction } from "../../custom/commonFunction";

export default function ListComponent() {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const [category1, setCategory1] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [pageCount, setPageCount] = useState(1);
  const [isLoader, setLoader] = useState(false);
  let { documentList, menuToggle } = useSelector((state) => ({
    documentList: state.documentReducer.document,
    menuToggle: state.commonReducer.menuToggle,
  }));

  // const [currentFolder, setCurrentFolder] = useState([]);
  // const [category1, setCategory1] = useState()
  const [isMobile, setisMobile] = useState(false);
  const [isCancelMobile, setisCancelMobile] = useState(false);
  const [iswebMobile, setWebMobile] = useState(false);
  const paginglist = [
    { label: "5", value: 5 },
    { label: "10", value: 10 },
    { label: "20", value: 20 },
    { label: "50", value: 50 },
  ];
  const paginglistDefault = [{ label: "20", value: 20 }];

  useEffect(() => {
    /*  fetchData(); */

    const intervals = setInterval(() => {
      resize();
    }, 10);
    return () => clearInterval(intervals);
  }, []);

  const fetchData = async () => {
    setLoader(true);
    let apiUrl = `${POST_CATEGORIES}`;
    const pageDetails = {
      pageNumber: currentPage,
      pageSize: perPage,
    };

    axios({
      method: "POST",
      url: apiUrl,
      data: pageDetails,
    })
      .then((response) => {
        setLoader(false);
        if (response?.status === 200) {
          setCategory1(response.data);
          dispatch(setCategoryData(response.data));
          setPageCount(response.data.totalCount);

          // console.log(response.data)
        }
      })
      .catch((err) => {
        setLoader(false);
        logoutFunction(err?.response?.status);
      });
  };

  useEffect(() => {
    setCategory1(documentList);
  }, [documentList]);

  const handleClick = (id) => {
    nav(`${id}`);
  };

  const resize = () => {
    if (window.innerWidth < 850) {
      setisMobile(true);
    } else {
      setisMobile(false);
    }

    if (window.innerWidth < 400) {
      setWebMobile(true);
    } else {
      setWebMobile(false);
    }
    if (window.innerWidth < 315) {
      setisCancelMobile(true);
    } else {
      setisCancelMobile(false);
    }
  };

  /////////////////////////////////// pagination /////////////////////////////////////////

  //   const find = e => {
  //     // console.log(e)
  //         setPerPage(parseInt(e.value) )
  //   }
  //   const previousPage = () => {
  //         setCurrentPage(current => current - 1)
  // }

  //   const nextPage = () => {
  //     setCurrentPage(current => current + 1)
  // }

  useEffect(() => {
    fetchData();
    // console.log({currentPage, pageCount, perPage})
  }, [currentPage, perPage]);

  const find = (e) => {
    setPerPage(parseInt(e.value));
    const selectedPage = 1;
    setCurrentPage(selectedPage);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <ToastContainer
        limit={1}
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {isLoader && (
        <div className="spinner_overlay">
          <div className="loader">
            <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
          </div>
        </div>
      )}
      <div className="titleContainer">
        <div className="title">
          <img src={document} />
          <span>Documents</span>
        </div>
        <div className="category">
          <span className="catActive">Documents</span>
        </div>
      </div>
      {category1?.values?.length > 0 ? (
        <div
          className="fileList"
          style={{ marginTop: window.innerWidth < 850 ? "109px" : "122px" }}
        >
          <table className="fileListTable">
            {/* <thead style={{position:'fixed', backgroundColor:'#fff', width:'100%', marginTop:'3px', zIndex:'1'}}> */}
            <thead>
              <tr>
                <td>
                  <div>
                    {/* <img src={blankFile} alt='' />  */}
                    <span>Name</span>
                    {/* <img src={downArrow} alt='' />  */}
                  </div>
                </td>
              </tr>
            </thead>

            {/* <tbody style={{top:'52px', position:'relative', marginBottom:'110px'}}> */}
            <tbody>
              {category1?.values?.map((list, index) => {
                return (
                  <tr
                    key={index}
                    onClick={() =>
                      handleClick(list.category1Id, list.category1Name)
                    }
                  >
                    <td>
                      <img src={folder} alt="" />{" "}
                      <span>{list.category1Name}</span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <>
          <span className="empty1">{category1 && "Empty"}</span>
        </>
      )}

      <div
        className={`${
          isMobile
            ? "common-mobilesubmenu mobile-pagination"
            : menuToggle
            ? "common-submenu sidemenu-pagination"
            : "common-submenu web-pagination"
        } pb-2 pt-2`}
      >
        {category1?.values?.length > 0 && (
          <table width="100%">
            <tbody>
              <tr>
                <td width="8%" className="p-3">
                  <div
                    className={`${
                      iswebMobile ? "mobilePageSelect" : "webpageSelect"
                    }`}
                  >
                    <Select
                      options={paginglist}
                      defaultValue={paginglistDefault}
                      classNamePrefix="paging"
                      isSearchable={false}
                      menuPlacement={"top"}
                      menuPosition={"fixed"}
                      onChange={(e) => find(e)}
                    />
                  </div>
                </td>
                <td
                  width="92%"
                  className={`text-end ${
                    isCancelMobile ? "pagination-padd" : "p-3"
                  }`}
                >
                  {isMobile ? (
                    <Pagination
                      prevPageText={
                        <>
                          {" "}
                          <img src={LeftArrowIcon} />
                        </>
                      }
                      nextPageText={
                        <>
                          <img src={RightArrowIcon} />{" "}
                        </>
                      }
                      linkClassNext="nextArrow"
                      linkClassPrev="prevArrow"
                      itemClass={`page-item`}
                      linkClass="page-link"
                      pageRangeDisplayed={1}
                      onChange={(e) => handlePageChange(e)}
                      activePage={currentPage}
                      totalItemsCount={pageCount}
                      itemsCountPerPage={perPage}
                    />
                  ) : (
                    <Pagination
                      prevPageText={
                        <>
                          {" "}
                          <img src={LeftArrowIcon} />
                        </>
                      }
                      nextPageText={
                        <>
                          <img src={RightArrowIcon} />{" "}
                        </>
                      }
                      linkClassNext="nextArrow"
                      linkClassPrev="prevArrow"
                      itemClass={`page-item`}
                      linkClass="page-link"
                      pageRangeDisplayed={4}
                      onChange={(e) => handlePageChange(e)}
                      activePage={currentPage}
                      totalItemsCount={pageCount}
                      itemsCountPerPage={perPage}
                    />
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </div>

      {/* <div className={`${window.innerWidth < 850 ? "common-mobilesubmenu mobile-pagination" :menuToggle? "common-submenu sidemenu-pagination": "common-submenu web-pagination" } pb-2`}>
          <table width="100%">
                            <tbody>
                                <tr>
                                    <td width="8%" className='p-3'>
                                        <div style={{ minWidth: '80px', maxWidth: '80px' }}>
                                            <Select
                                                options={paginglist}
                                                defaultValue={paginglistDefault}
                                                classNamePrefix="paging"
                                                isSearchable={false}
                                                menuPlacement={"top"}
                                                menuPosition={'fixed'}
                                                onChange={e => find(e)}
                                            />
                                        </div>
                                    </td>
                                    <td width="92%" className='text-end p-3'>
                                        {currentPage == 1 ? '' : <img src={arrowleft} className='px-1 cursor-pointer' onClick={previousPage} />}<label className="text-12-bold">{currentPage}</label>{pageCount === currentPage ? '' : <img src={arrowright} className='px-1 cursor-pointer' onClick={nextPage} />}
                                    </td>
                                </tr>
                            </tbody>
          </table>
        </div> */}
    </>
  );
}
